import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { Storefront, BookOpen } from "@phosphor-icons/react";

const fmtMoney = (n) => `$${Number(n).toFixed(2)}`;

export default function Templates() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/templates").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl">
      <div className="gf-overline">Marketplace</div>
      <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tight mt-2">
        Business templates.
      </h1>
      <p className="text-zinc-600 mt-3 max-w-2xl text-sm leading-relaxed">
        Step-by-step guides ($10–$15) on how to start, buy, or operate a business — written by
        Claude Sonnet 4.5 and curated by our admins. One-time purchase, lifetime access.
      </p>

      {items.length === 0 ? (
        <div className="mt-10 border border-zinc-200 bg-white p-12 text-center">
          <Storefront size={36} className="mx-auto text-zinc-400" />
          <div className="gf-overline mt-3">Nothing here yet</div>
          <p className="text-zinc-600 mt-2 text-sm">
            New templates will appear here once published.
          </p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 mt-10">
          {items.map((t) => (
            <Link
              to={`/templates/${t.id}`}
              key={t.id}
              data-testid={`template-card-${t.id}`}
              className="border border-zinc-200 bg-white p-6 hover:bg-zinc-50 flex flex-col"
            >
              <div className="flex items-center justify-between">
                <div className="gf-overline">{t.category}</div>
                {t.owned ? (
                  <span className="text-xs px-2 py-0.5 border bg-emerald-50 text-emerald-700 border-emerald-200 font-mono uppercase tracking-wider">
                    Owned
                  </span>
                ) : (
                  <span className="font-display font-black text-xl tracking-tight">{fmtMoney(t.price_usd)}</span>
                )}
              </div>
              <h3 className="font-display font-bold text-lg mt-3 leading-tight">{t.title}</h3>
              <p className="text-sm text-zinc-600 mt-2 leading-relaxed flex-1">{t.summary}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-blue-700 font-semibold text-sm uppercase tracking-wide">
                <BookOpen size={14} /> {t.owned ? "Read now" : "Preview & buy"} →
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
